module.exports = __webpack_public_path__ + "img/mood-icon-2.3f41818b.svg";